import { Component, OnInit, ViewChild } from "@angular/core";
import { AbstractControl, FormControl, FormGroup, Validators } from "@angular/forms";
import { InAppBrowser } from "@awesome-cordova-plugins/in-app-browser";

import { DepositMainLabels } from "../cashier-models/interfaces";
import { ECheckModel } from "../cashier-models/models";
import { CashierBase } from "../../cashier-base/cashier-base";
import { IonContent, LoadingController, NavParams, Platform, PopoverController } from "@ionic/angular";
import { ConfigService } from "src/app/services/config/config.service";
import { CashierService } from "src/app/services/cashier/cashier.service";
import { SuccessMessageService } from "src/app/services/message-provider/success-message.service";
import { EventsService } from "src/app/services/event/event.service";
import { UtilsService } from "src/app/services/utils/utils.service";
import { CashierContentService } from "src/app/services/cashier/cashier-content.service";
import { Navigator } from "src/app/services/routing/navigator";


@Component({
  selector: "page-deposit-e-check-base",
  templateUrl: "deposit-e-check-base.html",
})
export class DepositECheckBasePage extends CashierBase implements OnInit {
    @ViewChild("Content") content: IonContent;

    public objectKeys = Object.keys;
  
    // public amount: string;
    private bonusCode: string;
    private bonusID: string;
  
    public buttonDisabled: boolean = false;
    public showInstaDebit: boolean = false;
    private savedCards: Array<any> = [];
    private savedAccounts: Array<any> = [];
  
    public selectedBonusItem: string;
  
    // enroll form
    public depositForm: FormGroup;
  
    public defaultAmounts: any = [];
    private paymentType: any = [];
    public vendorLogoUrl: string = "";
  
    private inputIDebitAmount: AbstractControl;
    public amountSubmitted: number;
  
    public labels: DepositMainLabels;
    public newWindow;
  
    public paypalEmail = "";
    public accountsList = null;
    public loading;
    public minAmount;
  
    // Payment Succesfull Variables
    public params;
    public paymentRequestID;
    public customerId;
    public sessionToken;
  
    public check_deposit_complete: boolean = false;
    public check_deposit_result: string;
  
    constructor(
      protected config: ConfigService,
      protected cashierProvider: CashierService,
      protected successMessageService: SuccessMessageService,
      protected events: EventsService,
      protected navParams: NavParams,
      protected utils: UtilsService,
      private navigator:Navigator,
      public platform: Platform,
      private contentProvider: CashierContentService,
      private loadingController: LoadingController,
      protected popoverCtrl: PopoverController
    ) {
      super();
  
      this.labels = new ECheckModel();
  
      this.bonusCode = navParams.get("bonusCode");
  
      this.successMessageService.clearMessage();
  
      if (!!this.navParams.get("bonusOffer"))
        this.bonusCode = this.navParams.get("bonusOffer");
  
      if (!!this.navParams.get("navigateBackPage")) {
        this.loading = this.loadingController.create({
          message: "Loading E-check...",
        });
  
        this.loading.then(l => {
          l.present();
        });
  
        setTimeout(() => this.loading.then(l => {
          l.dismiss();
        }), 650);
      }
    }
  
    ngOnInit() {
      this.buttonDisabled = false;
  
      this.depositForm = new FormGroup({
        inputIDebitAmount: new FormControl("", [Validators.required]),
      });
      this.inputIDebitAmount = this.depositForm.get("inputIDebitAmount");
    }
  
    ionViewWillEnter() {
      let vm = this;
  
      this.contentProvider
        .getPageConfig("echeck")
        .then((response: DepositMainLabels) => {
          this.labels = response;
        });
  
      //Webservice Calls to get Credit Card Data
  
      this.cashierProvider.getActivePaymentTypes("ACH").subscribe(
        (response: any) => {
          if (response.result) {
            console.log("Payment Details", response.payload);
            vm.paymentType = response.payload;
            vm.minAmount = this.paymentType[0].min;
            // vm.onPaymentType(0);
  
            let i: number = 0;
            this.defaultAmounts = [];
  
            while (i < 11) {
              if (
                typeof vm.paymentType[0]["default_amt_" + (i + 1)] !== "undefined"
              ) {
                vm.defaultAmounts.push(
                  vm.paymentType[0]["default_amt_" + (i + 1)]
                );
              } else {
                break;
              }
              i++;
            }
            vm.vendorLogoUrl = vm.utils.getCDNAsset(
              "deposit/" + vm.paymentType[0].image_url
            );
          }
        },
        (error) => {}
      );
      this.onGetAccounts();
    }
  
    selectedDepositBonusOffer($event) {
      this.bonusCode = $event.selectedbonusOffer.campaign_code;
    }
  
    showLoading() {
      this.hideLoading();
      this.loading = this.loadingController.create({
        message: "Checking Account...",
      });
      this.loading.present();
    }
  
    hideLoading() {
      try {
        this.loading.dismiss();
      } catch (e) {}
    }

    onGetAccounts() {
        this.savedCards = [];
        this.savedAccounts = [];
        this.cashierProvider.callListAccounts().subscribe(
          (response: any) => {
            if (response && !!response.result) {
              var tempCards: any = response.payload;
              for (let index in tempCards) {
                if (
                  tempCards[index].paymentTypeCode == "VI" ||
                  tempCards[index].paymentTypeCode == "MC"
                ) {
                  this.savedCards.push(tempCards[index]);
                } else if (tempCards[index].paymentTypeCode == "ACH") {
                  this.savedAccounts.push(tempCards[index]);
                }
              }
            }
          },
          (error) => {
            //this.error = error;
          }
        );
      }
  
    onSubmit() {
     
        if (this.savedAccounts.length > 0) {
            this.navigator.navigateTo(
              "DepositECheckPage",
              { multipleModals: true },
              {
                amount: this.inputIDebitAmount.value,
                bonusCode: this.bonusCode,
                bonusID: this.bonusID,
              }
            );
          } else {
            this.navigator.navigateTo(
              "DepositECheckAddPage",
              { multipleModals: true },
              {
                amount: this.inputIDebitAmount.value,
                bonusCode: this.bonusCode,
                bonusID: this.bonusID,
              }
            );
          }
    }
  
    get isMobile() {
      return this.platform.is("mobile") || this.platform.is("mobileweb")
        ? true
        : false;
    }
  
    isMobileApp() {
      return this.platform.is("cordova");
    }
  
    onBack = () => {
      if (!!this.navParams.get("navigateBackPage")) {
        let navigateBackPage = this.navParams.get("navigateBackPage");
        if (navigateBackPage == "default") {
          //Navigator.toLobby();
          this.navigator.navigateTo("DepositMainComponent", { multipleModals: true });
        } else {
          this.navigator.navigateTo(navigateBackPage);
        }
      } else {
        this.navigator.back();

      }
    };
  
    onBonusSelect(index, offer) {
      this.bonusCode = offer.campaign_code;
      this.selectedBonusItem = index;
  
      //Deposit Event Information
      this.bonusID = offer.id;
    }
  
    onAmountSelected(amount) {
      this.inputIDebitAmount.setValue(amount);
      this.depositForm.get("inputIDebitAmount").markAsDirty();
      this.depositForm.get("inputIDebitAmount").markAsTouched();
    }
  
    // For Checking Payment Success
  
    getHashValue(key) {
      var matches = location.hash.match(new RegExp(key + "=([^&]*)"));
      return matches ? matches[1] : null;
    }
}